module.exports = __webpack_public_path__ + "img/banner-zero-hunger.44a2e6e4.png";